import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import FreightForm from "./Modules/DocumentScan/form";
import Search from "./Modules/DocumentScan/search";
import Header from "./Header";
import Footer from "./Footer";
import SearchForm from "./Pages/SearchForm";
import Dashboard from "./Pages/Dashboard";
import Shipments from "./Modules/Invoice";
import SignIn from "./Pages/SignIn";
import RegisterCompany from "./Pages/RegisterCompany";
import FullScreenSpinner from "./components/FullScreenSpinner";
import UserActivity from "./Profile/UserActivity";
import ModulesPricing from "./Profile/modules-pricing";
import Users from "./Profile/Users";
import QuickBooks from "./components/QuickBooks";
import CompanyDetails from "./Pages/CompanyDetails";
import LexChat from "./components/LexChat";

import LandingPage from "./Pages/LandingPage";
import Analytics from "./Profile/companyAdmin/Analytics";
import Contact from "./Pages/Contact";
import Support from "./Pages/Support";
import Referrals from "./Profile/referrals";
import ForgotPassword from "./Pages/ForgotPassword";
import QuicksightAnalytics from "./Profile/companyAdmin/QuicksightAnalytics";
import Settings from "./Profile/Settings";
import SetupAuthenticator from "./Pages/SetupAuthenticator";
import Requests from "./Profile/Requests";


export const UserGroupsContext = React.createContext([]);

function App() {

  const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") === "true");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAuth = localStorage.getItem('authenticated');
    if (storedAuth) {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const onLoginSuccess = () => {
    setAuthenticated(true);
    localStorage.setItem('authenticated', true);
    navigate('/home');
  };

  if (loading) {
    return <FullScreenSpinner />;
  }

  return (
    <div style={{ overflowY: 'hidden', paddingBottom: '1px' }}>
      <Header />
      <Routes>
        {/* Base Path Redirection */}
        <Route
          path="/"
          element={<Navigate to={authenticated ? "/dashboard" : "/home"} replace />}
        />

        <Route path="/signin" element={<SignIn onLoginSuccess={onLoginSuccess} />} />
        <Route path="/register" element={<RegisterCompany />} />
        <Route path="/setup-mfa" element={<SetupAuthenticator />} />
        <Route path="/home" element={
          authenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />
        } />
        <Route path="/contact-cm" element={
          authenticated ? <Navigate to="/dashboard" replace /> : <Contact />
        } />
        <Route path="/support" element={<Support />} />
        <Route path="/forgot-password" element={
          authenticated ? <Navigate to="/dashboard" replace /> : <ForgotPassword />
        } />

        {(authenticated || authenticated === 'true') ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route exact path="/bol/:id" element={<FreightForm />} />
            <Route exact path="/pa/:id" element={<FreightForm />} />
            <Route exact path="/pod/:id" element={<FreightForm />} />
            <Route exact path="/da/:id" element={<FreightForm />} />
            <Route path="/search/:bolid" element={<SearchForm />} />
            <Route path="/search" element={<Search />} />
            <Route path="/invoice-module" element={<Shipments />} />
            <Route path="/user-activity" element={<UserActivity />} />
            <Route path="/modules-pricing" element={<ModulesPricing />} />
            <Route path="/users" element={<Users />} />
            <Route path="/qb" element={<QuickBooks />} />
            <Route path="/company-list" element={<CompanyDetails />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/quicksight-analytics" element={<QuicksightAnalytics />} />
            <Route path="/settings" element={<Settings />} />
            {/* <Route path="/requests" element={<Requests />} /> */}
            <Route path="*" element={<Navigate to="/dashboard" />} />

          </>
        ) : (
          <Route path="*" element={<Navigate to="/home" />} />
        )}
      </Routes>
      {(authenticated || authenticated === 'true') && <LexChat />}
      <Footer />
    </div>
  );
}

export default App;